import axios from 'axios';
import toast from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
   baseURL: API_URL,
   headers: {
      'Content-Type': 'application/json',
   },
});

// Add token to requests if available
api.interceptors.request.use(
   (config) => {
      // Check if we're in browser environment
      if (typeof window !== 'undefined') {
         const token = localStorage.getItem('token');
         if (token) {
            config.headers.Authorization = `Bearer ${token}`;
         }
      }
      return config;
   },
   (error) => {
      return Promise.reject(error);
   }
);

// Handle response errors
api.interceptors.response.use(
   (response) => response,
   (error) => {
      if (error.response?.status === 401 && typeof window !== 'undefined') {
         localStorage.removeItem('token');
         localStorage.removeItem('user');
      }
      return Promise.reject(error);
   }
);

export default api;
